// extracted by mini-css-extract-plugin
export default {"comments":"PostComments_comments__6N3op","single":"PostComments_single__BMQUT"};